import { styled } from 'styled-components';
import { componentColors } from '@foradevelopment/design-tokens/nested';

import { Colors } from '../../utils';
import { Container } from '../Layout';
import { SpeechBubbleTriangle } from './SpeechBubbleTriangle';

const defaultOffsetHeight = 14;

const IconWrapper = styled.div<{ $offsetHeight: number }>`
  position: absolute;
  top: -${props => props.$offsetHeight}px;
`;

type SpeechBubbleCommonProps = {
  negativeSideMargins?: boolean;
  illustration?: React.ReactNode;
  offsetHeight?: number;
  marginTop?: number;
  children: React.ReactNode;
};

type SpeechBubbleVariantProps = {
  /** Background variant (can't be combined with color) */
  variant?: keyof typeof componentColors.component.color.background.box;
  /** Background color (can't be combined with color) */
  color?: never;
};

type SpeechBubbleColorProps = {
  /** Background variant (can't be combined with color) */
  variant?: never;
  /** Background color (can't be combined with variant) */
  color?: Colors;
};

type ConditionalProps = SpeechBubbleVariantProps | SpeechBubbleColorProps;
type SpeechBubbleProps = SpeechBubbleCommonProps & ConditionalProps;

export const SpeechBubble = ({
  color = 'black05',
  variant,
  offsetHeight = defaultOffsetHeight,
  illustration,
  marginTop,
  children,
  negativeSideMargins = true,
}: SpeechBubbleProps) => (
  <Container
    backgroundColor={color}
    paddingTop={negativeSideMargins ? [30, 40, 40] : [10, 20, 20]}
    paddingBottom={negativeSideMargins ? [30, 40, 40] : [10, 20, 20]}
    marginRight={negativeSideMargins ? [-20, -80, -40] : []}
    marginTop={marginTop}
    marginLeft={negativeSideMargins ? [-20, -80, -40] : []}
    paddingRight={negativeSideMargins ? [20, 80, 40] : [20, 40, 40]}
    paddingLeft={negativeSideMargins ? [20, 80, 40] : [20, 40, 40]}
    position="relative"
    {...(variant ? { style: { backgroundColor: componentColors.component.color.background.box[variant] } } : {})}
  >
    <IconWrapper $offsetHeight={offsetHeight}>
      {illustration ?? (
        <SpeechBubbleTriangle height={offsetHeight} backgroundColor={color} {...(variant ? { variant } : {})} />
      )}
    </IconWrapper>
    {children}
  </Container>
);
